import { Fragment } from 'react';

import useNationalTeamApparel from './UseNationalTeamApparel';

import ApparelFormGrid from '../../../components/grids/apparelForm/ApparelFormGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import { LOADING_MSG } from '@usas/ui-web/utils/Constants';

const NationalTeamApparel = () => {
  const {
    isLoading,
    personId,
    gridData,
    competitionGenderTypeCode,
    onSubmitApparelForm
  } = useNationalTeamApparel();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Apparel</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12">
          <ApparelFormGrid
            gridData={gridData}
            personId={personId}
            competitionGenderTypeCode={competitionGenderTypeCode}
            onSubmitFormCallback={onSubmitApparelForm} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default NationalTeamApparel;